import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1ProjectIDOCToArray} from "../../../../util/Payload";

/**
 * The project folders, read through the service that owns them.
 *
 * `performQuery` IS THE WHOLE REASON A NON-SPECIES CAN USE THIS MACHINERY. An Enterprise Component
 * does not have to be an object-revision projection -- it has to be able to fetch a page of records
 * and hand them to the buffer. So a plain table with a REST service of its own gets the platform's
 * table for free: paging, sorting, search, the column picker and the card view, none of which this
 * feature has to implement or keep in step.
 *
 * PAGING IS THE SERVER'S. `List Projects` takes Limit, Offset and Sort and answers with the FULL
 * total as Count, which is what the table divides by the page size to work out how many pages
 * exist. Slicing client-side would have made every page after the first unreachable through the
 * only control that reaches them.
 */
class ProjectEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const idocResponse = this.getIDOCResponse() ?? "v1.Project-001";

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/projects",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                // THE FILTERS THE PAGE SET, carried on the component so a refetch keeps them --
                // paging to the second page of "open projects" must not quietly widen to all.
                ...(this.getAttributeValue("Status") ? {Status: this.getAttributeValue("Status")} : {}),
                ...(this.getAttributeValue("CustomerObjectUSID")
                    ? {CustomerObjectUSID: this.getAttributeValue("CustomerObjectUSID")} : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ProjectEnterpriseComponent;
